import React from 'react'
import PropTypes from 'prop-types'
import { Container, Header, Footer } from './LandingLayout.styles'

const LandingLayout = ({
  children,
  footer = null,
  header = null
}) => {
  return (
    <Container>
      {header && <Header>{header}</Header>}
      {children}
      {footer && <Footer>{footer}</Footer>}
    </Container>
  )
}

LandingLayout.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  header: PropTypes.node
}

export default LandingLayout
